import ContactForm, { defaultContactElements } from "../../layouts/declarations/Sections/ContactForm";
import CommodityCodes from "../../layouts/declarations/Sections/CommodityCodes";
import LocationOfGoods, { locationOfGoodsElements } from "../../layouts/declarations/Sections/LocationOfGoods";
import { capitalize } from "lodash";

// Custom sections are ones that could have their values stored in its database table and loaded from there

export const headerContactSections = ['exporter', 'importer', 'declarant', 'representative'];
export const itemContactSections = ['buyer', 'seller'];
export const contactSections = [
    ...itemContactSections, ...headerContactSections
];
export const customSections = [...contactSections, 'locationOfGoods', 'commodityCodes'];

// Retrieve all element names of the passed name of a custom section
export const getCustomSectionElements = (sectionName) => {
    if (contactSections.includes(sectionName)) {
        return defaultContactElements;
    } else if (sectionName === 'locationOfGoods') {
        return locationOfGoodsElements
    } else if (sectionName === 'commodityCodes') {
        // TODO: Add commodity codes elements
    }
};

export const getCustomSectionLabel = (sectionName) => {
    if (contactSections.includes(sectionName)) {
        return `${capitalize(sectionName)} Contact`
    } else if (sectionName === 'locationOfGoods') {
        return 'Location of Goods'
    } else if (sectionName === 'commodityCodes') {
        return "Commodity COdes"
    }
};

const CustomSections = (props) => {
    const { section, itemIndex } = props;

    if (contactSections.includes(section)) return (
        <ContactForm
            formName={capitalize(section)} formRole={section}
            itemSection={`contact${capitalize(section)}`}
            itemIndex={itemIndex}
        />
    )

    if (section === 'locationOfGoods') return (
        <LocationOfGoods />
    )

    if (section === 'commodityCodes') return (
        <CommodityCodes
            itemIndex={itemIndex}
        />
    )
};

export default CustomSections;